(function () {
    // The user clicked on one of the product thumbnails for more information
    function relatedProductClicked(productId) {
        // Only display the product the customer clicked on
        $(".related-product-thumbnails").addClass("d-none");
        $(".related-product-display").addClass("d-none");
        $(".related-product-display[data-product-id='" + productId + "']").removeClass("d-none");
    }

    // Update the add to cart button and quantity selector to indicate safety stock & max order quantity
    function processSafetyStock() {
        let $selectedVariant = $(`.variant[data-option1="${selectedVariants[0]}"][data-option2="${selectedVariants[1]}"][data-option3="${selectedVariants[2]}"]`);

        if ($selectedVariant.length <= 0) {
            return;
        }

        // Calculate the max quantity based on the inventory level of the selected variant.
        var maxOrderQuantityMetafield = Number($("#quantity").data("max-order-quantity"));
        // Get the product and the variant safety stock metafields and use the lesser of the two.
        var safetyStockMetafield = Math.min(Number($("#quantity").data("safety-stock")), Number($selectedVariant.data("safety-stock")));
        // Subtract the safety stock from the inventory quantity to get the max quantity.
        var maxQuantity = Number($selectedVariant.data("inventory-quantity")) - safetyStockMetafield;
        
        // If there is also a max order quantity metafield, use the lesser of the two.
        if(maxOrderQuantityMetafield && maxOrderQuantityMetafield != 0) {
            maxQuantity = Math.min(maxOrderQuantityMetafield, maxQuantity);
        }
        // Set the max quantity for the quantity selector
        $("#quantity").prop("max", maxQuantity);
        $("#add-to-cart-validation .col").text("Max Quantity of " + maxQuantity);

        if (Boolean($selectedVariant.data("available"))) {
            $("button.add-to-cart").text("Add to Cart");
            $("button.add-to-cart").prop("disabled", false);
        }
        else {
            $("button.add-to-cart").text("Out of Stock");
            $("button.add-to-cart").prop("disabled", true);
        }
    }

    // Function to check if the element is in view
    function isInView(element) {
        var elementTop = element.offset().top;

        // Account for the header and a little buffer room to display the footer
        var viewportTop = $(window).scrollTop() + $("#header").outerHeight() + element.outerHeight();

        return elementTop > viewportTop;
    }

    // this array holds the selected variants
    var selectedVariants = [];

    // update the variant title, vendor, description, and variant images to the selected variant options
    function updateVariantTextAndImages() {
        let $selectedVariant = $(`.variant[data-option1="${selectedVariants[0]}"][data-option2="${selectedVariants[1]}"][data-option3="${selectedVariants[2]}"]`);

        // Check to make sure that $selectedVariant has at least one result. No results means there is only one variant
        // for this product and the field, text, and images are not displayed and should not be updated.
        if ($selectedVariant.length) {
            $("#variant-id").val($selectedVariant.data("variantId"));
            $(".variant-selection-text").text($selectedVariant.data("title"));
            $("#footer-variant-name").text($selectedVariant.data("title"));
            $(".variant-selection-vendor").text($selectedVariant.data("vendor"));
            $("#variant-selection-description").html($selectedVariant.data("description"));

            for(i=1; i<=3; i++){
                $(`label[data-variant-group="${i}"] img`).each(function() {
                    let variantOptions = [...selectedVariants];
                    variantOptions[i-1] = $(this).data("variant")
                    let $selectedImg = $(`.variant[data-option1="${variantOptions[0]}"][data-option2="${variantOptions[1]}"][data-option3="${variantOptions[2]}"] a img`);
                    $(this).attr("alt", $selectedImg.attr("alt"))
                    $(this).attr("src", $selectedImg.attr("src"))
                });
            }
        }
    }

    document.addEventListener("DOMContentLoaded", function () {
        // The user clicked on one of the product thumbnails for more information
        $(".related-products a").on("click", function (e) {
            var $relatedProduct = $(e.target).closest(".related-product");
            var productId = $relatedProduct.data("productId");
            relatedProductClicked(productId);
        });

        // The user closed out of viewing one of the product details
        $(".related-products a.close-button").on("click", function (e) {
            e.preventDefault();

            // Hide all of the product details, and show the thumbnails again
            $(".related-product-display").addClass("d-none");
            $(".related-product-thumbnails").removeClass("d-none");
        });

        // Wire up the quantity selector
        $("#quantity").on("change", function () {
            var quantity = Number($("#quantity").val());
            // Get the max quantity allowed for this product.
            var maxQuantity = Number($("#quantity").attr("max"));
            var productId = Number($("#quantity").attr("data-product-id"));

            // If max quantity is enabled
            if(maxQuantity) {
                var max = maxQuantity;

                // Check the existing items in the cart to make sure we're accounting for those too.
                // Subtract the cart quantity from the max allowed amount.
                if (window["Rebuy"] && window.Rebuy["Cart"]) {
                    var cart = window.Rebuy.Cart.getCart();
                    if (cart) {
                        var item = cart.items.filter(i => i.product.id == productId)[0];
                        if (item) {
                            max = maxQuantity - item.quantity;
                        }
                    }
                }
    
                if (max < 0) {
                    max = 0;
                }
    
                // If the quantity is above the max allowed amount, display a validation message & disallow the quantity increase.
                if (quantity > max) {
                    $("#add-to-cart-validation").removeClass("d-none");
                    $("#quantity").val(max);
                } else if (quantity == 0) {
                    $("#add-to-cart-button").attr("disabled", true);
                } else {
                    $("#add-to-cart-validation").addClass("d-none");
                    $("#add-to-cart-button").attr("disabled", false);
                }
            }
        });

        // Wire up the quantity selector
        $(".add-quantity").on("click", function (e) {
            e.preventDefault();

            var quantity = Number($("#quantity").val());

            if (!quantity) {
                quantity = 1;
            }

            quantity++;

            $("#quantity").val(quantity);
            $("#quantity").trigger("change");
        });

        // Wire up the quantity selector
        $(".subtract-quantity").on("click", function (e) {
            e.preventDefault();

            var quantity = Number($("#quantity").val());

            if (!quantity) {
                quantity = 1;
            }

            quantity--;

            if (quantity <= 0) {
                quantity = 1;
            }

            $("#quantity").val(quantity);
            $("#quantity").trigger("change");
        });

        // Listen to the scroll event to determine if the call to action is visible, and if not, to display the sticky footer.
        $(window).on("scroll", function () {
            var $addToCartButton = $("#add-to-cart-button");
            var $stickyFooter = $(".add-to-cart-footer");
            if (isInView($addToCartButton)) {
                $stickyFooter.addClass('d-none');
            } else {
                $stickyFooter.removeClass('d-none');
            }
        });

        selectedVariants = [
            $(".variant").data('option1'),
            $(".variant").data('option2'),
            $(".variant").data('option3')
        ];

        // variant-group-label is the class for each of the labels in the variant group
        $(".variant-group-label").on("click", function(e) {
            // we use currentTarget because we have images wrapped in labels. If you click the image target is the image, but currentTarget will always give us the label.
            selectedVariants[e.currentTarget.dataset.variantGroup - 1] = e.currentTarget.dataset.title;

            updateVariantTextAndImages();
            processSafetyStock();
        });

        updateVariantTextAndImages();

        processSafetyStock();
    });
})();